import { CreditFacilityDraftPage } from "features/credit-facility/CreditFacilityDraftPage";
import { useCreditFacilityRetrieveSuspense } from "gen/endpoints/credit-facility/credit-facility";
import React from "react";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs } from "shared/components/layout/PageTabs";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const CreditFacilitySettingsPage: React.FC = () => {
  const { t } = useTranslation(["creditFacility"]);

  const { fundFamilyId, creditFacilityId } = useRequiredStringParams();

  const { data: creditFacility } = useCreditFacilityRetrieveSuspense(
    fundFamilyId,
    creditFacilityId,
  );

  if (creditFacility.state === "draft") {
    return <CreditFacilityDraftPage />;
  }

  return (
    <PageContent>
      <PageHeader title={t("creditFacility:edit.title")} />
      <PageBody>
        <PageTabs />
      </PageBody>
    </PageContent>
  );
};
